import { render } from "./Login.vue?vue&type=template&id=5a010c4e&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5a010c4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a010c4e"

export default script